/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from "react";

import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  changeSidebarTheme,
  changeSidebarType,
  toggleRightSidebar,
  changeTopbarTheme,
  changeLayoutWidth,
} from "../../store/layout/actions";

// Layout Related Components
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import Rightbar from "../CommonForBoth/Rightbar";

//i18n
import { withTranslation } from "react-i18next";

const Layout = ({ t, children }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [isMobile] = useState(
    /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
  );
  const {
    layoutWidth,
    leftSideBarTheme,
    leftSideBarType,
    topbarTheme,
    isPreloader,
    showRightSidebar,
  } = useSelector((state) => state.Layout);

  const toggleRightSidebarFunc = () => {
    dispatch(toggleRightSidebar());
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(1).toUpperCase() + string.slice(2);
  };

  useEffect(() => {
    if (isPreloader === true) {
      if (document.getElementById("preloader")) {
        document.getElementById("preloader").style.display = "block";
      }
      if (document.getElementById("status")) {
        document.getElementById("status").style.display = "block";
      }
      setTimeout(function () {
        if (document.getElementById("preloader")) {
          document.getElementById("preloader").style.display = "none";
        }
        if (document.getElementById("status")) {
          document.getElementById("status").style.display = "none";
        }
      }, 2500);
    } else {
      if (document.getElementById("preloader")) {
        document.getElementById("preloader").style.display = "none";
      }
      if (document.getElementById("status")) {
        document.getElementById("status").style.display = "none";
      }
    }

    // Scroll Top to 0
    window.scrollTo(0, 0);
    let currentage = t(capitalizeFirstLetter(history.location.pathname));

    document.title = currentage + " | Tech4Humans";
    if (leftSideBarTheme) {
      dispatch(changeSidebarTheme(leftSideBarTheme));
    }

    if (layoutWidth) {
      dispatch(changeLayoutWidth(layoutWidth));
    }

    if (leftSideBarType) {
      dispatch(changeSidebarType(leftSideBarType));
    }
    if (topbarTheme) {
      dispatch(changeTopbarTheme(topbarTheme));
    }

    if (showRightSidebar) {
      toggleRightSidebarFunc();
    }
  }, [dispatch]);

  const toggleMenuCallback = () => {
    if (leftSideBarType === "default") {
      dispatch(changeSidebarType("condensed", isMobile));
    } else if (leftSideBarType === "condensed") {
      dispatch(changeSidebarType("default", isMobile));
    }
  };
  return (
    <React.Fragment>
      <div id="preloader">
        <div id="status">
          <div className="spinner-chase">
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
          </div>
        </div>
      </div>

      <div id="layout-wrapper">
        {history.location.pathname !== "/attachments-interaction" && (
          <Header
            toggleMenuCallback={toggleMenuCallback}
            toggleRightSidebar={toggleRightSidebarFunc}
          />
        )}
        <Sidebar
          theme={leftSideBarTheme}
          type={leftSideBarType}
          isMobile={isMobile}
        />
        <div
          className={`${
            history.location.pathname !== "/attachments-interaction" &&
            "main-content"
          }`}
        >
          {children}
        </div>
        {history.location.pathname !== "/chats" &&
          history.location.pathname !== "/attachments-interaction" &&
          history.location.pathname !== "/manager-panel" && <Footer />}
      </div>
      <Rightbar />
    </React.Fragment>
  );
};
export default withTranslation()(Layout);
